import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ACCESS_LEVEL_LABELS, getAccessLevelName as getAccessLevelNameFn } from '../../constants/access-levels';
import { UsersService } from '../../services/users.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
	selector: 'app-user-create',
	templateUrl: './user-create.component.html',
	styleUrls: ['./user-create.component.scss']
})
export class UserCreateComponent implements OnInit, AfterViewInit {
	title = 'New User';
	user: any = {};
	users: any = [];
	userForm: UntypedFormGroup;
	systemForm: UntypedFormGroup;
	userdetails: any = [];
	locations: any = [];
	userlocations: any = [];
	usergroups: any = [];
	yesno: any = [
		{ value: '0', name: 'No' },
		{ value: '1', name: 'Yes' }
	];

	accessLevels = ACCESS_LEVEL_LABELS;

	formEditAllowed = [
		'userid',
		'password',
		'realname',
		'phone',
		'email',
		'defaultlocation',
		'fullaccess',
		'cancreatetender',
		'editinv',
		'dispatchadmin',
		'customeradmin',
		'user_group',
		'empcode',
		'salesman'
		//'phoneno',
	]

	userid: any = '';
	color: any = 'blue';
	defaultlocation: any;
	recs: any = [];
	activeStep: any;
	emailRegex = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
	phoneRegex = '^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$';
	empcodes: any = false;
	existingUserids = new Set<string>();
	useridTakenSuggest = '';
	hidePassword = true;
	private lastSuggestedUserid = '';

	constructor(private route: ActivatedRoute, private formBuilder: UntypedFormBuilder, private userService: UsersService, public router: Router, private location: Location, public globalSearchService: GlobalSearchService, private globalsService: GlobalsService) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.userForm = this.formBuilder.group({
			userid: ['', [Validators.required, Validators.pattern('[-_a-zA-Z0-9]*')]],
			password: ['', Validators.required],
			realname: ['', Validators.required],
			phone: ['', Validators.pattern(this.phoneRegex)],
			email: ['', Validators.pattern(this.emailRegex)],
		});

		this.systemForm = this.formBuilder.group({
			defaultlocation: ['', Validators.required],
			fullaccess: ['1', Validators.required],
			empcode: [''],
			salesman: [''],
			user_group: ['', Validators.required],
			customeradmin: ['1'],
			cancreatetender: ['1'],
			editinv: ['1'],
			dispatchadmin: ['0'],
			isPOSUser: [false],
			isSalesman: [false],
			commissionrate1: [''],
			csremails: [''],
			commlock: [0],
			chatid: [''],
			group_id: ['1'],
			group_level: ['0'],
			group_type: ['1'],
		});

		this.userForm.markAllAsTouched();
		this.systemForm.markAllAsTouched();
		this.user['locations'] = [];

		this.getEmployeeCodes();

		this.systemForm.get('isPOSUser')?.valueChanges.subscribe(enabled => {
			const ctrl = this.systemForm.get('empcode');
			if (enabled) {
				ctrl?.setValidators([Validators.required]);
			} else {
				ctrl?.clearValidators();
				ctrl?.reset();
			}
			ctrl?.updateValueAndValidity();
			ctrl?.markAsTouched();
		});

		this.systemForm.get('isSalesman')?.valueChanges.subscribe(enabled => {
			const fields = [
				'salesman', 'commissionrate1', 'csremails', 'commlock',
				'chatid', 'group_id', 'group_level', 'group_type'
			];
			const emailUser = this.userForm.get('email');

			if (enabled) {
				this.systemForm.get('salesman')?.setValidators([Validators.required]);
				//this.systemForm.get('csremails')?.setValidators([Validators.required]);
				//emailUser?.setValidators([Validators.required, Validators.pattern(this.emailRegex)]);
			} else {
				this.systemForm.get('salesman')?.clearValidators();
				this.systemForm.get('csremails')?.clearValidators();
				emailUser?.setValidators([Validators.pattern(this.emailRegex)]);
				fields.forEach(field => this.systemForm.get(field)?.reset());
			}

			fields.forEach(field => {
				const ctrl = this.systemForm.get(field);
				ctrl?.updateValueAndValidity();
				ctrl?.markAsTouched();
			});
			emailUser?.updateValueAndValidity();
			emailUser?.markAsTouched();
		});

		this.systemForm.get('empcode').valueChanges.subscribe((newV) => {
			if (Object.keys(this.empcodes).includes(newV) && newV !== '') {
				this.systemForm.get('empcode').setErrors({ 'error': true });
			} else {
				this.systemForm.get('empcode').setErrors(null);
				this.systemForm.updateValueAndValidity();
			}
		});

		this.userForm.get('realname')?.valueChanges.subscribe((name) => {
			const useridVal = (this.userForm.get('userid')?.value || '').trim();
			if (!useridVal || useridVal === this.lastSuggestedUserid) {
				const base = this.baseUseridFromName(name);
				if (base) {
					const suggested = this.firstAvailableUserid(base).toUpperCase();
					this.lastSuggestedUserid = suggested;
					this.userForm.get('userid')?.setValue(suggested, { emitEvent: false });
					this.useridTakenSuggest = '';
					this.userForm.get('userid')?.updateValueAndValidity();
				}
			}
		});

		this.userForm.get('userid')?.valueChanges.subscribe(() => {
			this.validateUseridTaken();
		});
	}

	loading = false;

	getEmployeeCodes() {
		this.userService.getUsers().subscribe((res: any) => {
			const codes: Record<string, string> = {};
			this.existingUserids.clear();
			(res || []).forEach((emp: any) => {
				if (emp.empcode) codes[emp.empcode] = emp.userid;
				if (emp.userid) this.existingUserids.add((emp.userid as string).toLowerCase());
			});
			this.empcodes = codes;
			this.validateUseridTaken();
		});
	}

	private baseUseridFromName(fullName: string): string {
		if (!fullName || typeof fullName !== 'string') return '';
		const words = fullName.trim().split(/\s+/).filter(w => w.length > 0);
		if (words.length === 0) return '';
		if (words.length === 1) return words[0].toLowerCase().replace(/[^a-z0-9_-]/g, '');
		const first = words[0];
		const last = words[words.length - 1];
		const base = (first.charAt(0) + last).toLowerCase().replace(/[^a-z0-9_-]/g, '');
		return base || words[0].toLowerCase().replace(/[^a-z0-9_-]/g, '');
	}

	private firstAvailableUserid(base: string): string {
		if (!base) return '';
		const lower = base.toLowerCase();
		if (!this.existingUserids.has(lower)) return base;
		for (let n = 2; n <= 999; n++) {
			const candidate = lower + n;
			if (!this.existingUserids.has(candidate)) return candidate;
		}
		return lower + Date.now().toString(36);
	}

	generatePassword(): void {
		const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
		let pass = '';
		for (let i = 0; i < 6; i++) {
			pass += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		this.userForm.get('password')?.setValue(pass);
	}

	suggestUseridFromName(): void {
		const realname = this.userForm.get('realname')?.value;
		const base = this.baseUseridFromName(realname);
		if (!base) return;
		const suggested = this.firstAvailableUserid(base).toUpperCase();
		this.lastSuggestedUserid = suggested;
		this.userForm.get('userid')?.setValue(suggested);
		this.useridTakenSuggest = '';
		this.userForm.get('userid')?.updateValueAndValidity();
	}

	private validateUseridTaken(): void {
		const ctrl = this.userForm.get('userid');
		const val = (ctrl?.value || '').trim();
		if (!val) {
			this.useridTakenSuggest = '';
			ctrl?.setErrors(ctrl?.errors ? { ...ctrl.errors } : null);
			return;
		}
		const lower = val.toLowerCase();
		if (this.existingUserids.has(lower)) {
			const base = this.baseUseridFromName(this.userForm.get('realname')?.value) || lower.replace(/\d+$/, '') || lower;
			this.useridTakenSuggest = this.firstAvailableUserid(base).toUpperCase();
			ctrl?.setErrors({ ...(ctrl.errors || {}), taken: true });
		} else {
			this.useridTakenSuggest = '';
			const errs = ctrl?.errors;
			if (errs && errs['taken']) {
				const { taken, ...rest } = errs;
				ctrl?.setErrors(Object.keys(rest).length ? rest : null);
			}
		}
		ctrl?.updateValueAndValidity();
	}

	createUser() {
		if (this.userForm.valid && this.systemForm.valid && !this.loading) {
			this.loading = true;

			const formData = {
				...this.userForm.value,
				...this.systemForm.value
			};

			this.userService.createUser(this.userForm.get('userid').value, formData).subscribe({
				next: (results) => {
					this.user.user = results;
					this.globalSearchService.showNotification('Updated', 'success', 'bottom', 'right');
					this.updateLocations();
					this.location.back();
				},
				error: (err) => {
					console.error('Create user failed:', err);
					this.globalSearchService.showNotification('Failed to create user', 'danger', 'bottom', 'right');
				},
				complete: () => {
					this.loading = false;
				}
			});
		}
	}

	ngAfterViewInit() {
		this.globalsService.getLocations().subscribe(details => {
			this.locations = details || [];
			if (this.locations.length === 1) {
				const loc = this.locations[0];
				this.user.locations.push(loc);
				this.locations = [];
				this.defaultlocation = loc;
				this.systemForm.get('defaultlocation')?.setValue(loc.loccode);
				this.sortlocations();
			}
		});

		this.globalsService.getAllLocations().subscribe(details => {
			this.recs = details || [];
		});

		this.userService.getUserGroups().subscribe(groups => {
			this.usergroups = groups;
		});
	}

	updateLocations() {

		const data = {
			userid: this.userid == '' ? this.userForm.get('userid').value : this.userid,
			locations: this.user.locations
		};


		this.userService.updateUserLocations(data).subscribe((user: any) => {
			this.user = user;
		});
	}

	addUserLocation(loc: any) {
		const index = this.locations.indexOf(loc)
		this.locations.splice(index, 1);
		this.user.locations.push(loc)

		this.sortlocations();
	}

	removeUserLocation(loc: any) {

		if (loc == this.defaultlocation) {
			alert('Can not remove default location from the list.');
			return;
		}
		const index = this.user.locations.indexOf(loc)
		this.user.locations.splice(index, 1);
		this.locations.push(loc)
		this.sortlocations();

	}

	sortlocations() {
		this.locations.sort((n1, n2) => n1.loccode - n2.loccode);
		this.user.locations.sort((n1, n2) => n1.loccode - n2.loccode);
	}

	defaultLocation(event: any): void {
		if (!event?.value || !Array.isArray(this.locations) || !Array.isArray(this.user?.locations)) {return;}
	
		const newLocCode = event.value;
	
		// Find the new default location (from either list)
		const newLocation = this.locations.find(loc => loc.loccode === newLocCode)
			|| this.user.locations.find(loc => loc.loccode === newLocCode);
	
		if (!newLocation || (this.defaultlocation?.loccode === newLocCode)) {return;}
	
		// Move previous default back to location pool if it exists
		if (this.defaultlocation) {
			this.locations.push(this.defaultlocation);
			this.user.locations = this.user.locations.filter(loc => loc.loccode !== this.defaultlocation.loccode);
		}
	
		// Remove new location from existing pools to avoid duplication
		this.locations = this.locations.filter(loc => loc.loccode !== newLocCode);
		this.user.locations = this.user.locations.filter(loc => loc.loccode !== newLocCode);
	
		// Set new default and push to user locations
		this.defaultlocation = newLocation;
		this.user.locations.push(newLocation);
	
		this.sortlocations();
	}

	back(): void {
		this.location.back()
	}

	translate_yn(input: any) {
		if (input == 0 || input == 1) {
			return input == 0 ? 'No' : 'Yes';
		} else {
			return '?';
		}
	}

	getAccessLevelName(value: string): string {
		return getAccessLevelNameFn(value);
	}

	translate_usergroup(input: any) {
		if (input != '') {
			return this.usergroups.filter(group => (group['user_group_id'] == input))[0]['name'];
		} else {
			return '';
		}
	}

	logStep(event: any) {
		this.activeStep = event.selectedIndex;
	}

	format_phone(input: HTMLInputElement): void {
		if (!input || typeof input.value !== 'string') {return;}
	
		const digits = input.value.replace(/\D/g, '').slice(0, 10); // limit to 10 digits max
	
		let formatted = '';
	
		if (digits.length >= 6) {
			formatted = `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6)}`;
		} else if (digits.length >= 3) {
			formatted = `(${digits.slice(0, 3)})${digits.slice(3)}`;
		} else {
			formatted = digits;
		}
	
		input.value = formatted;
	}


}